import axios from 'axios';
import store from '@/store';
import { baseURL, apiHost, contentType, method, requestTimeout, tokenName } from '@/config';
import qs from 'qs';

const instance = axios.create({
  baseURL,
  method: method,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
});

instance.interceptors.request.use(
  (config) => {
    if (store.getters['user/xbtToken'] && !config.flag) {
      config.headers[tokenName] = store.getters['user/xbtToken'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.request.use(
  (config) => {
    if (config.header) {
      Object.keys(config.header).forEach((item) => {
        config.headers[item] = config.header[item];
      });
    }
    if (store.getters['user/accessToken'] && !config.flag) {
      config.headers[tokenName] = 'Bearer ' + store.getters['user/accessToken'];
    }
    if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8') {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
